import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui'
import { ScrollText } from 'lucide-react'

export function TermsOfService() {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-primary/20 to-purple-500/20">
            <ScrollText className="h-6 w-6 text-primary" />
          </div>
          <div>
            <h1 className="text-2xl font-bold tracking-tight">Terms of Service</h1>
            <p className="text-muted-foreground">Last updated: August 25, 2025</p>
          </div>
        </div>
      </div>

      <Card className="glass">
        <CardHeader>
          <CardTitle className="text-lg">SCB|PH Terms of Service v2.0</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-invert prose-sm max-w-none space-y-6">
          <section className="space-y-2">
            <h3 className="text-base font-semibold text-primary">1. Scope of Services</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Services are designated exclusively for educational purposes, offering guidance and information.
              Users must employ them responsibly while adhering to applicable laws.
            </p>
          </section>

          <section className="space-y-2">
            <h3 className="text-base font-semibold text-primary">2. Intellectual Property</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              The platform's original content, features, and functionality belong entirely to the service provider.
              All materials are protected by copyright, trademark, and other laws. Unauthorized reproduction or
              distribution triggers immediate access termination.
            </p>
          </section>

          <section className="space-y-2">
            <h3 className="text-base font-semibold text-primary">3. Refund and Transferability Policy</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              All services are non-refundable and non-transferable. Any exception to this policy is at the sole
              discretion of the system.
            </p>
          </section>

          <section className="space-y-2">
            <h3 className="text-base font-semibold text-primary">4. Disclaimer of Liability</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              The provider is not liable for any damage, harm, or loss arising from the use of our services.
              Accuracy and reliability of results are not guaranteed.
            </p>
          </section>

          <section className="space-y-2">
            <h3 className="text-base font-semibold text-primary">5. Prohibited Uses</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Users cannot employ services for unlawful purposes. Automated bots attempting to access the
              service face blocking. Violations result in immediate termination.
            </p>
          </section>

          <section className="space-y-2">
            <h3 className="text-base font-semibold text-primary">6. Termination</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              The provider may suspend access immediately, without prior notice, for any breach or reason.
            </p>
          </section>

          <section className="space-y-2">
            <h3 className="text-base font-semibold text-primary">7. Governing Law</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              These terms are governed by and construed in accordance with the laws of the jurisdiction where the
              provider operates.
            </p>
          </section>

          <section className="space-y-2">
            <h3 className="text-base font-semibold text-primary">8. Changes to Terms</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              We reserve the right to modify these terms at our sole discretion. We will provide at least 30 days'
              notice for material changes.
            </p>
          </section>

          <section className="space-y-2">
            <h3 className="text-base font-semibold text-primary">9. Contact Us</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              If you have any questions about these Terms, please contact us at{' '}
              <a href="/contact" className="text-primary hover:underline">scbphil.com/contact</a>.
            </p>
          </section>
        </CardContent>
      </Card>
    </div>
  )
}
